import React, { useState } from "react";
import Meta from "../../components/Meta";

// Original navbar component
import MegaMenu from "../../components/MegaMenu2";
import GetDemoModal from "../../components/modal/GetDemoModal";

// Modern landing components
import {
  HeroModern,
  StatsSection,
  FeaturesModern,
  TestimonialSection,
  HowItWorksSection,
  IntegrationsSection,
  CTASection,
  FooterModern
} from "../../components/landing";

const Home_1 = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  return (
    <main className="bg-[#F3F1FA] min-h-screen">
      <Meta title="SynthiaHire - AI-Powered BFSI Recruitment" />
      
      {/* Original MegaMenu Navbar */}
      <MegaMenu onGetDemo={() => setIsDemoModalOpen(true)}>
        {/* Hero Section */}
        <HeroModern onGetDemo={() => setIsDemoModalOpen(true)} />
        
        {/* Stats Section */}
        <StatsSection />
        
        {/* How It Works */}
        <HowItWorksSection />
        
        {/* Features/Superpowers */}
        <FeaturesModern />
        
        {/* Testimonial */}
        <TestimonialSection />
        
        {/* Integrations */}
        <IntegrationsSection />
        
        {/* CTA Section */}
        <CTASection onGetDemo={() => setIsDemoModalOpen(true)} />
        
        {/* Footer */}
        <FooterModern onGetDemo={() => setIsDemoModalOpen(true)} />
      </MegaMenu>

      <GetDemoModal 
        open={isDemoModalOpen} 
        onCancel={() => setIsDemoModalOpen(false)} 
      />
    </main>
  );
};

export default Home_1;
